module.exports = __webpack_public_path__ + "static/media/chalkboard.a0fadc70.png";